import { ITongHopNamRequest } from "../../model/request/tong-hop-diem/ITongHopNamRequest";
import { apiClient } from "../apiClient";

export const TONG_HOP_NAM_ENDPOINT = "diem/tong-hop-nam";
export const tongHopNamApi = {
    Select: (request: ITongHopNamRequest) => apiClient.post(`${TONG_HOP_NAM_ENDPOINT}`, request),
};